console.log("dpdWrapper");

/* Drop-down wrapper */

// Définitions de bases

const dpdContainer = document.querySelectorAll(".dpd-wrapper-container");
if (document.querySelector(".dpd-wrapper-container")) {
  console.log("dpd elem detected");
}
let nbExpanded = 0;

// false => caché

// listener ajouté globalement à tout le container wrapper
if (dpdContainer) {
  dpdContainer.forEach((dpdContainerElement) => {
    dpdContainerElement.addEventListener("click", (event) => {
      //Vérifier que la cible du clic est l'élément dpdw-btn
      const dpdBtnClass = "dpdw-btn";
      let idDpdBtn = event.target.getAttribute("class");
      if (idDpdBtn) {
        const index = idDpdBtn.indexOf(dpdBtnClass);
        idDpdBtn = idDpdBtn.slice(index, index + dpdBtnClass.length);
      }
      if (idDpdBtn != dpdBtnClass) {
      }
      return idDpdBtn === dpdBtnClass ? dpdToggle(dpdContainerElement) : null;
    });
  });
}

// Fonction modifiant l'état du wrapper
const dpdToggle = (dpdContainerElement) => {
  const dpdElem = event.target.closest(".dpdw-elem");
  const dpdBody = dpdElem.querySelector(".dpdw-body");
  const dpdBtn = dpdElem.querySelector(".dpdw-btn");
  let height = 0;
  dpdBody.childNodes.forEach((element) => {
    height += outerHeight(element);
  });
  let dpdState = dpdElem.dataset.expanded;
  if (dpdState === "false") {
    dpdBody.style.maxHeight = height + "px";
    dpdBtn.classList.add("body-visible");
    dpdElem.dataset.expanded = "true";
    dpdBtn.classList.add("body-visible");
    nbExpanded++;
    if (dpdElem.dataset.scrollbar && dpdElem.dataset.scrollbar === "true") {
      dpdContainerElement.classList.add("dpd-wrapper_scrollbar");
    }
  } else {
    dpdBody.style.maxHeight = 0;
    dpdBody.style.overflow = "hidden";
    dpdBtn.classList.remove("body-visible");
    dpdElem.dataset.expanded = "false";
    nbExpanded--;
    if (dpdElem.dataset.scrollbar && nbExpanded === 0) {
      // dpdContainerElement.querySelector(".dpdw-btn").scrollIntoView(true);
      dpdContainerElement.scrollTop = 0;
      dpdContainerElement.classList.remove("dpd-wrapper_scrollbar");
    }
  }
};

/**
 * Returns the element height including margins
 * @param element - element
 * @returns {number}
 */
function outerHeight(element) {
  const height = element.offsetHeight,
    style = window.getComputedStyle(element);
  const marginHeight = ["top", "bottom"]
    .map((side) => parseInt(style[`margin-${side}`]))
    .reduce((total, side) => total + side, height);
  const paddingHeight = ["top", "bottom"]
    .map((side) => parseInt(style[`padding-${side}`]))
    .reduce((total, side) => total + side, height);
  return paddingHeight + marginHeight;
}
